import hasEnoughPopulatedFields from '@features/supplies/handlers/track-trace/client/hasEnoughPopulatedFields';

const elem: HTMLFormElement | null = document.querySelector(
  'form#xrx-track-trace-search-form'
);

let ttSolution = '';

const FRIENDLY_CAPTCHA_MODULE_SCRIPT_URL =
  'https://cdn.jsdelivr.net/npm/friendly-challenge@0.9.14/widget.module.min.js';
const FRIENDLY_CAPTCHA_SCRIPT_URL =
  'https://cdn.jsdelivr.net/npm/friendly-challenge@0.9.14/widget.min.js';

const submitButton = elem?.querySelector('button.xrx-fw-cta[type="submit"]');
const formContainer = submitButton?.parentNode;

if (formContainer) {
  const frcDiv = document.createElement('div');
  frcDiv.className = 'xrx-fw-frc xrx-track-trace';
  formContainer.appendChild(frcDiv);
}

if (
  !document.querySelector(
    `script[src*='${FRIENDLY_CAPTCHA_MODULE_SCRIPT_URL}']`
  ) &&
  !document.querySelector(`script[src*='${FRIENDLY_CAPTCHA_SCRIPT_URL}']`)
) {
  const friendlyCaptchaScript = document.createElement('script');
  friendlyCaptchaScript.setAttribute('defer', '');
  friendlyCaptchaScript.setAttribute('async', '');
  friendlyCaptchaScript.onload = initFriendlyCaptcha;

  if ('noModule' in HTMLScriptElement.prototype) {
    friendlyCaptchaScript.type = 'module';
    friendlyCaptchaScript.src = FRIENDLY_CAPTCHA_MODULE_SCRIPT_URL;
  } else {
    friendlyCaptchaScript.setAttribute('nomodule', '');
    friendlyCaptchaScript.src = FRIENDLY_CAPTCHA_SCRIPT_URL;
  }

  document.body.appendChild(friendlyCaptchaScript);
}

/**
 * Init Friendly Captcha.
 */
function initFriendlyCaptcha() {
  const ttCaptchaElement = elem?.querySelector('.xrx-track-trace');
  const sitekey = elem?.querySelector<HTMLInputElement>('#frc_sitekey')?.value;

  if (ttCaptchaElement && sitekey) {
    let locale = 'en-us';
    if (
      window.digitalData &&
      window.digitalData.locale &&
      window.digitalData.locale['url-prefix']
    ) {
      locale = window.digitalData.locale['url-prefix'];
    }

    const [language] = locale.split('-');

    if (window.friendlyChallenge) {
      const submitButton = elem?.querySelector<HTMLButtonElement>(
        'button.xrx-fw-cta[type="submit"]'
      );

      if (submitButton) {
        submitButton.disabled = true;
      }

      new window.friendlyChallenge.WidgetInstance(ttCaptchaElement, {
        doneCallback: frcDone,
        sitekey,
        startMode: 'focus',
        language,
        solutionFieldName: 'frc_solution',
      });
    }
  }
}

/**
 *
 * Friendly Captcha done callback.
 *
 * @param solution - Returned solution key.
 */
function frcDone(solution: string) {
  ttSolution = solution;
  const submitButton = elem?.querySelector<HTMLButtonElement>(
    'button.xrx-fw-cta[type="submit"]'
  );

  if (submitButton) {
    submitButton.disabled = false;
  }
}

if (elem) {
  let clicked = false;
  elem.addEventListener('submit', function (e) {
    if (!clicked) {
      clicked = true;
      const submitButton = elem?.querySelector<HTMLButtonElement>(
        'button.xrx-fw-cta[type="submit"]'
      );
      e.preventDefault();
      if (!hasEnoughPopulatedFields()) {
        const errorElem = document.querySelector(
          'div.xrx-fw-form__content__message.xrx-fw-form__content__message--error'
        );
        if (errorElem) {
          errorElem.removeAttribute('style');
        }
        clicked = false;
      } else {
        const containerElem: HTMLDivElement | null =
          document.querySelector('#xrx-body');
        if (containerElem) {
          if (ttSolution !== '') {
            if (submitButton) {
              submitButton.disabled = true;
            }
            elem.submit();
            return true;
          } else {
            if (submitButton) {
              submitButton.disabled = false;
            }
            clicked = false;
            return false;
          }
        }
      }
    }
  });
}
